export const VERSION = "v1";
const basePath = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BASE_PATH) ? process.env.REACT_APP_BASE_PATH : '';
export const API_URL = `${basePath}/api/${VERSION}/`;

/*All Pages Slugs*/
export const LOGIN = `login`;
export const SIGNUP = `signup`;
export const FORGOTPASSWORD = `forgotpassword`;
export const RESETPASSWORD = `resetpassword`;
export const ACTIVATE = `activate`;
export const OTPVERIFY = `otpverify`;
export const DASHBOARD = `home`;
export const QUIZ = `quiz`;
export const PREDICT = `predict`;
export const PROFILE = `profile`;
export const SHAREWIN = `sharewin`;
export const REFEREWIN = `referewin`;
export const LEADERBOARD = `leaderboard`;
export const UPCOMING_MATCH_QUIZE = `upcoming-match-quiz`;

/* Authentication API Endpoints */
export const CHECKLOGIN = `auth/checkLogin`;
export const SIGNUPUSER = `auth/signup`;
export const ACTIVATEACCOUNT = `auth/activateAccount`;
export const RESENDOTP = `auth/resendOTP`;
export const FORGOTPASS = `auth/forgotpassword`;
export const VERIFYPASSWORDRESETOTP = `auth/verifyPasswordResetOTP`;
export const RESETPASS = `auth/resetpassword`;
export const GETREFERRALPROGRESS = `auth/referralProgress`;


/* User API Endpoints*/
export const GETUSER = `user`;
export const UPDATEUSER = `user/update`;
export const GETUSERWALLETHISTORY = `user/getAllWalletHistory`;
export const GETUSERTANSACTIONS = `user/getAllTransactions`;
export const GETUSERCOUPONS = `user/getAllCoupons`;
export const ADDWITHDRAWREQUEST = `user/addWithdrawRequest`;


/* Default Settings Endpoints */
export const GETCONFIG = `config`;
export const GETFAQS = `config/faqs`;
export const GETGAMES = `config/games`;
export const GETADS = `config/ads`;